export default {
  ticketList: [], // 门票查询、查到的门票列表数据
  refund: {} // 门票操作 - 退票按钮，查询到的数据
};
